import { addClass, removeClass } from './helpers'

function initializeMenu() {
    const hamb = document.querySelector('.hamburger');
    const menu = document.querySelector('#menu');
    const overlay = document.querySelector('.overlay');
    const body = document.querySelector('body');
    const openMenuClass = 'open-menu';
    let scrollPosition = null;

    function checkIsOpen() {
        function hideMenu() {
            menu.style.display = 'none';
        }

        menu.isOpen = !menu.isOpen;
        if (menu.isOpen) {
            menu.style.display = 'block';
            addClass(menu, openMenuClass)
            menu.style.translate3d = 200 + 'px,0,0';
            menu.style.transition = 'transform .2s ease-in-out';
            overlay.style.display = 'block';
            overlay.addEventListener('click', addCheckIsOpen, false);
            body.style.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            body.style.overflow = 'hidden';
            scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
            window.scrollTo(0, 0);
        } else {
            removeClass(menu, openMenuClass);
            overlay.style.display = 'none';
            body.style.height = 'auto';
            body.style.overflow = 'auto';
            menu.style.translate3d = -200 + 'px,0,0';
            menu.style.transition = 'transform .2s ease-in-out';

            setTimeout(hideMenu, 300);
            if (scrollPosition) {
                window.scrollTo(0, scrollPosition);
                scrollPosition = null;
            }
        }
    }

    function addCheckIsOpen() {
        checkIsOpen();
        overlay.removeEventListener('click', addCheckIsOpen);
    }

    if (menu) {
        menu.isOpen = false;

        menu.style.translate3d = (-200) + 'px,0,0';
    }
    if (hamb) {
        hamb.addEventListener('click', checkIsOpen, false);
    }
}

module.exports = initializeMenu;



// WEBPACK FOOTER //
// ./src/js/menu.js